import styles from './styles.module.scss';

interface PrimaryButtonProps {
    onClick: () => void;
    text: string;
    width?: string;
    height?: string;
    className?: string;
    disabled?: boolean;
    loading?: boolean;
    loadingText?: string;
}
import CircularProgress from '@mui/material/CircularProgress';

export default function PrimaryButton({
    onClick,
    text,
    width = '100%',
    height = '48px',
    className = '',
    disabled = false,
    loading = false,
    loadingText = '',
}: PrimaryButtonProps) {
    return (
        <button
            onClick={onClick}
            className={`${styles.primaryBtn}
            ${disabled || loading ? styles.buttonDisabled : ''}
            ${className}`}
            style={{ width, height }}
            disabled={disabled}
        >
            {loading && (
                <CircularProgress
                    style={{ marginInlineEnd: '10px' }}
                    size={'1rem'}
                />
            )}

            {loading ? loadingText : text}
        </button>
    );
}
